import * as dom from './wpstg-dom-utils.js';
import WpstgSidebarMenu from './wpstg-sidebar-menu.js';
import WpstgContactUs from './wpstg-contact-us';

/**
 * Enable/Disable cloning for staging site
 */
export default class WpstgCloneStaging {
  constructor(
      pageWrapperId = '#wpstg-clonepage-wrapper',
      wpstgObject = wpstg,
  ) {
    this.pageWrapper = dom.qs(pageWrapperId);
    this.wpstgObject = wpstgObject;
    this.enableButtonId = '#wpstg-enable-staging-cloning';
    this.enableAction = 'wpstg_enable_staging_cloning';

    this.notyf = new Notyf({
      duration: 10000,
      position: {
        x: 'center',
        y: 'bottom',
      },
      dismissible: true,
      types: [
        {
          type: 'warning',
          background: 'orange',
          icon: false,
        },
      ],
    });
    this.init();
  }

  addEvents() {
    if (this.pageWrapper === null) {
      return;
    }

    dom.addEvent(this.pageWrapper, 'click', this.enableButtonId, () => {
      this.sendRequest(this.enableAction);
    });
    new WpstgSidebarMenu();
  }

  init() {
    this.addEvents();
  }

  sendRequest(action) {
    fetch(this.wpstgObject.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: new URLSearchParams({
        action: action,
        accessToken: this.wpstgObject.accessToken,
        nonce: this.wpstgObject.nonce,
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }

      return Promise.reject(response);
    }).then((data) => {
      // Reload current page if successful.
      if ('undefined' !== typeof (data.success) && data.success) {
        location.reload();
        return;
      }

      // There will be message probably in case of error
      if ('undefined' !== typeof (data.message)) {
        this.notyf.error(data.message);
        return;
      }

      this.notyf.error(this.wpstgObject.i18n['somethingWentWrong']);
    }).catch((error) => {
      console.warn(this.wpstgObject.i18n['somethingWentWrong'], error);
    });
  }
}
